interface HRSidebarProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
  userName: string;
  onLogout: () => void;
}

const navItems = [
  { id: 'manager', icon: 'ri-user-heart-line', label: 'Мой менеджер' },
  { id: 'uploads', icon: 'ri-upload-cloud-2-line', label: 'Загрузка откликов' },
  { id: 'payments', icon: 'ri-wallet-3-line', label: 'Мои выплаты' },
  { id: 'requisites', icon: 'ri-file-list-3-line', label: 'Мои реквизиты', locked: true },
  { id: 'calculator', icon: 'ri-calculator-line', label: 'Калькулятор ЗП' },
];

export default function HRSidebar({ activeSection, onSectionChange, userName, onLogout }: HRSidebarProps) {
  const initials = userName
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0])
    .join('');

  return (
    <aside className="w-72 flex-shrink-0 bg-[#0d0f18] border-r border-[#1e2130] flex flex-col min-h-screen">
      {/* Logo */}
      <div className="px-6 py-5 border-b border-[#1e2130]">
        <img
          src="https://storage.readdy-site.link/project_files/2bf8aaf3-0f30-40d5-be17-1c495b690c02/c01c7bf6-da01-4692-a287-7cfb8ff624a9_lTZGkXUbeeGGTSg_1769785028.png?v=61d175ca0083da25e9bd41f5ab3012cf"
          alt="Логотип"
          className="h-9 object-contain"
        />
      </div>

      {/* Profile block */}
      <div className="px-6 py-6 border-b border-[#1e2130]">
        <div className="flex items-center gap-4">
          <div className="relative">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center text-white font-bold text-lg select-none">
              {initials || <i className="ri-user-star-line text-xl" />}
            </div>
            <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-amber-400 rounded-full border-2 border-[#0d0f18]" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-white truncate">{userName}</p>
            <p className="text-xs text-amber-500/80 mt-0.5">HR — менеджер</p>
          </div>
        </div>

        {/* Status badge */}
        <div className="mt-4 flex items-center gap-2 bg-amber-500/10 border border-amber-500/20 rounded-xl px-3 py-2.5">
          <span className="w-4 h-4 flex items-center justify-center flex-shrink-0">
            <i className="ri-information-line text-amber-400 text-sm" />
          </span>
          <span className="text-xs text-amber-400 leading-tight">
            Процесс трудоустройства ещё не завершен, часть функционала недоступна
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 py-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => {
          const isActive = activeSection === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onSectionChange(item.id)}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                isActive
                  ? 'bg-amber-500/15 text-amber-400 border border-amber-500/20'
                  : 'text-slate-400 hover:text-slate-200 hover:bg-[#13161f]'
              }`}
            >
              <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-base`} />
              </span>
              {item.label}
              {item.locked && (
                <span className="ml-auto w-4 h-4 flex items-center justify-center">
                  <i className="ri-lock-line text-xs text-slate-600" />
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Logout */}
      <div className="px-4 py-4 border-t border-[#1e2130]">
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm text-slate-500 hover:text-slate-300 hover:bg-[#13161f] transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-logout-box-r-line" />
          </span>
          Выйти из аккаунта
        </button>
      </div>

      {/* Bottom branding */}
      <div className="px-6 py-4 border-t border-[#1e2130]">
        <div className="relative">
          <div className="absolute -top-px left-0 right-0 h-px bg-gradient-to-r from-transparent via-emerald-500/20 to-transparent" />
        </div>
        <p className="text-[9px] text-slate-700 tracking-widest uppercase mb-0.5">© 2026 Корпоративный портал</p>
        <p
          className="text-[10px] font-bold tracking-[0.1em] uppercase"
          style={{ color: '#4ade8055' }}
        >
          «ПЛАТФОРМА РЕШЕНИЙ»
        </p>
      </div>
    </aside>
  );
}
